import { render } from "./ViewDashboard.vue?vue&type=template&id=6023b97c&ts=true"
import script from "./ViewDashboard.vue?vue&type=script&lang=ts"
export * from "./ViewDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__